/**
 * This file was automatically generated using "yarn generate:all" command.
 * Please do not edit it manually.
 * 
 * Generate source: local/cli/src/commands/placements/generate-intl-provider.ts
 **/


import { withIntlProvider } from '@post-office/placement-contexts/i18n';
import { messagesLoader as growthGrootMessages} from '@post-office/team-package--i18n--growth-groot'
import { messagesLoader as adminHubMessages} from '@post-office/team-package--i18n--admin-hub'
import { messagesLoader as catapultMessages} from '@post-office/team-package--i18n--catapult'
import { messagesLoader as belugasMessages} from '@post-office/team-package--i18n--belugas'
import { messagesLoader as rovoAgentsMessages} from '@post-office/team-package--i18n--rovo-agents'
import { messagesLoader as itsmAnalyticsMessages} from '@post-office/team-package--i18n--itsm-analytics'
import { messagesLoader as rohirrimMessages} from '@post-office/team-package--i18n--rohirrim'
import { messagesLoader as jsmGsMessages} from '@post-office/team-package--i18n--jsm-gs'
import { messagesLoader as editorCloudNativeMessages} from '@post-office/team-package--i18n--editor-cloud-native'
import { messagesLoader as commerceMessages} from '@post-office/team-package--i18n--commerce'
import { messagesLoader as postOfficeTeamMessages} from '@post-office/team-package--i18n--post-office-team'
import { messagesLoader as ccMigrationsToolingMessages} from '@post-office/team-package--i18n--cc-migrations-tooling'
import { messagesLoader as ccAiMessages} from '@post-office/team-package--i18n--cc-ai'
import { messagesLoader as growthTransmutersMessages} from '@post-office/team-package--i18n--growth-transmuters'
import { messagesLoader as growthMessages} from '@post-office/team-package--i18n--growth'
import { messagesLoader as ccAiGrowthMessages} from '@post-office/team-package--i18n--cc-ai-growth'
import { messagesLoader as fabricEditorMessages} from '@post-office/team-package--i18n--fabric-editor'
import { messagesLoader as ccFlywheelEngagementMessages} from '@post-office/team-package--i18n--cc-flywheel-engagement'
import { messagesLoader as growthConfluenceFindMessages} from '@post-office/team-package--i18n--growth-confluence-find'
import { messagesLoader as ccFlywheelActivationMessages} from '@post-office/team-package--i18n--cc-flywheel-activation'
import { messagesLoader as ccFlywheelFeatureDiscoveryMessages} from '@post-office/team-package--i18n--cc-flywheel-feature-discovery'
import { messagesLoader as cpqMessages} from '@post-office/team-package--i18n--cpq'
import { messagesLoader as crossFlowMessages} from '@post-office/team-package--i18n--cross-flow'
import { messagesLoader as jsmSequoiaMessages} from '@post-office/team-package--i18n--jsm-sequoia'
import { messagesLoader as playgroundMessages} from '@post-office/team-package--i18n--playground'
import { messagesLoader as alexstraszaMessages} from '@post-office/team-package--i18n--alexstrasza'
import { messagesLoader as aiopsGroguMessages} from '@post-office/team-package--i18n--aiops-grogu'
import { messagesLoader as growthStarburstMessages} from '@post-office/team-package--i18n--growth-starburst'
import { messagesLoader as growthLunaMessages} from '@post-office/team-package--i18n--growth-luna'
import { messagesLoader as axEpsilonMessages} from '@post-office/team-package--i18n--ax-epsilon'
import { messagesLoader as jiraYurreeMessages} from '@post-office/team-package--i18n--jira-yurree'
import { messagesLoader as aurumMessages} from '@post-office/team-package--i18n--aurum'
import { messagesLoader as jiraTanukiMessages} from '@post-office/team-package--i18n--jira-tanuki'
import { messagesLoader as searchPlexMessages} from '@post-office/team-package--i18n--search-plex'
import { messagesLoader as jiraCosmosMessages} from '@post-office/team-package--i18n--jira-cosmos'
import { messagesLoader as jiraGryffindorMessages} from '@post-office/team-package--i18n--jira-gryffindor'
import { messagesLoader as growthJiraOnboardingMessages} from '@post-office/team-package--i18n--growth-jira-onboarding'
import { messagesLoader as jiraEmpanadaMessages} from '@post-office/team-package--i18n--jira-empanada'
import { messagesLoader as jiraPandoraMessages} from '@post-office/team-package--i18n--jira-pandora'
import { messagesLoader as jiraPulsarMessages} from '@post-office/team-package--i18n--jira-pulsar'
import { messagesLoader as jsmSherpasMessages} from '@post-office/team-package--i18n--jsm-sherpas'
import { messagesLoader as jsmPhantomMessages} from '@post-office/team-package--i18n--jsm-phantom'
import { messagesLoader as jsmMegatronMessages} from '@post-office/team-package--i18n--jsm-megatron'
import { messagesLoader as jsmCoreCapabilitiesMessages} from '@post-office/team-package--i18n--jsm-core-capabilities'
import { messagesLoader as marketingMessages} from '@post-office/team-package--i18n--marketing'
import { messagesLoader as postOfficeTemplateMessages} from '@post-office/team-package--i18n--post-office-template'
import { messagesLoader as rovoExpansionMessages} from '@post-office/team-package--i18n--rovo-expansion'
import { messagesLoader as testMessagesMessages} from '@post-office/team-package--i18n--test-messages'
import { messagesLoader as confluenceIntegrationsMessages} from '@post-office/team-package--i18n--confluence-integrations'
import { messagesLoader as rovoChatMessages} from '@post-office/team-package--i18n--rovo-chat'
import { messagesLoader as designSystemMessages} from '@post-office/team-package--i18n--design-system'
import { messagesLoader as integrationsServiceMessages} from '@post-office/team-package--i18n--integrations-service'
import { messagesLoader as jsmNebulaMessages} from '@post-office/team-package--i18n--jsm-nebula'
import { messagesLoader as statuspageMessages} from '@post-office/team-package--i18n--statuspage'
import { messagesLoader as teamWolverineMessages} from '@post-office/team-package--i18n--team-wolverine'
import type { ComponentType } from 'react';

type TranslatedMessages = Record<string, string>;

type TranslatedMessagesResult<T> = { messages: T; errors: Array<string> };

const loadMessagesByTeam = async (locale: string): Promise<TranslatedMessagesResult<TranslatedMessages>> => {
return Promise.allSettled([
growthGrootMessages(locale),
adminHubMessages(locale),
catapultMessages(locale),
belugasMessages(locale),
rovoAgentsMessages(locale),
itsmAnalyticsMessages(locale),
rohirrimMessages(locale),
jsmGsMessages(locale),
editorCloudNativeMessages(locale),
commerceMessages(locale),
postOfficeTeamMessages(locale),
ccMigrationsToolingMessages(locale),
ccAiMessages(locale),
growthTransmutersMessages(locale),
growthMessages(locale),
ccAiGrowthMessages(locale),
fabricEditorMessages(locale),
ccFlywheelEngagementMessages(locale),
growthConfluenceFindMessages(locale),
ccFlywheelActivationMessages(locale),
ccFlywheelFeatureDiscoveryMessages(locale),
cpqMessages(locale),
crossFlowMessages(locale),
jsmSequoiaMessages(locale),
playgroundMessages(locale),
alexstraszaMessages(locale),
aiopsGroguMessages(locale),
growthStarburstMessages(locale),
growthLunaMessages(locale),
axEpsilonMessages(locale),
jiraYurreeMessages(locale),
aurumMessages(locale),
jiraTanukiMessages(locale),
searchPlexMessages(locale),
jiraCosmosMessages(locale),
jiraGryffindorMessages(locale),
growthJiraOnboardingMessages(locale),
jiraEmpanadaMessages(locale),
jiraPandoraMessages(locale),
jiraPulsarMessages(locale),
jsmSherpasMessages(locale),
jsmPhantomMessages(locale),
jsmMegatronMessages(locale),
jsmCoreCapabilitiesMessages(locale),
marketingMessages(locale),
postOfficeTemplateMessages(locale),
rovoExpansionMessages(locale),
testMessagesMessages(locale),
confluenceIntegrationsMessages(locale),
rovoChatMessages(locale),
designSystemMessages(locale),
integrationsServiceMessages(locale),
jsmNebulaMessages(locale),
statuspageMessages(locale),
teamWolverineMessages(locale),
]).then(results => {
return results.reduce((acc, result) => {
if (result.status === 'fulfilled') {
return {
messages: {
...acc.messages,
...result.value,
} as TranslatedMessages,
errors: [...acc.errors],
}
} else if (result.status === 'rejected') {
return {
messages: { ...acc.messages },
errors: [...acc.errors, `Failed to load translations with ${result.reason}`]
};
}
return acc;
}, { messages: {} as TranslatedMessages, errors: [] as Array<string> });
});
};

export { loadMessagesByTeam as loadPlacementMessages }

/**
 * New IntlProvider for InApp Placements with a restructured messagesLoader, being rolled out soon with Feature Flag
 **/
export const withScreenSpaceFlagsIntlProvider = <P extends object>(Component: ComponentType<P>): ComponentType<P &
{ messages?: TranslatedMessages }> => {
	return withIntlProvider<P, TranslatedMessages>(
		{
			messagesLoader: loadMessagesByTeam,
		},
		Component,
	);
};
